<div class="align-center mb-4">
    <div [innerHTML]="manifestoContent | safeHtml" class=""></div>
</div>
